import { FranchiseList } from '@components/pages/franchise/franchise-list'
import { MapComponent } from '@components/pages/franchise/map'
import { Pagination } from '@components/shared/pagination'
import { useFranchise } from 'context/franchise'
import styles from '@styles/pages/empresas.module.css'
import { FurnisherSidebar } from '../sidebar'

export const FranchisePageList = () => {
  const { isMap, params, totalFranchises, mapRef } = useFranchise()

  return (
    <>
      <FurnisherSidebar />
      {isMap ? (
        <MapComponent
          ref={mapRef}
          className={styles.main}
          style={{ height: '600px' }}
        />
      ) : (
        <div className={styles.main}>
          <FranchiseList />
          {totalFranchises && totalFranchises > 0 ? (
            <Pagination
              currentPage={params.page}
              total={totalFranchises}
              pageSize={9}
              queryParams={{ map: isMap ? 'on' : 'off' }}
            />
          ) : (
            <p>Nenhuma franquia encontrada</p>
          )}
        </div>
      )}
    </>
  )
}
